import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=a7919e84"
import script from "./BatchImport.vue?vue&type=script&lang=js"
export * from "./BatchImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports